import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import PermIdentity from '@material-ui/icons/PermIdentity'
import withStyles from '@material-ui/core/styles/withStyles'

import GridContainer from '../../../components/Grid/GridContainer.jsx'
import GridItem from '../../../components/Grid/GridItem.jsx'
import Card from '../../../components/Card/Card.jsx'
import CardBody from '../../../components/Card/CardBody.jsx'
import CardHeader from '../../../components/Card/CardHeader'
import CardIcon from '../../../components/Card/CardIcon'
import Button from '../../../components/CustomButtons/Button'
import Forwards from '../../../components/Forwards'
import { ForwardNewDetail } from './ForwardNewDetail'
import { cardTitle } from '../../../assets/jss/material-dashboard-pro-react.jsx'
import ForwardsList from "./ForwardsList";

const styles = {
    cardTitle,
    cardIconTitle: {
        ...cardTitle,
        marginTop: '15px',
        marginBottom: '0px',
        '& small': {
            fontSize: '80%',
            fontWeight: '400',
        },
    },
    cardCategory: {
        marginTop: '10px',
        color: '#999999 !important',
        textAlign: 'center',
    },
    description: {
        color: '#999999',
    },
    updateProfileButton: {
        float: 'right',
    },
    title: {
        color: '#3C4858',
        textDecoration: 'none',
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'space-between',
    },
}

const PastForwardsList = ({ fetchForwardList, classes, app_state }) => {
    const history = useHistory()
    const [modalState, setModalState] = useState(false);

    const toggleModal = bool => {
        setModalState(bool)
    }

    if (!app_state.current_client) {
        return null
    }
    if (app_state.current_client.account_status == 1) {
        history.push('/pending-registration')
    }
    if (app_state.current_client.account_status == 5) {
        history.push('/registration')
    }
    if (app_state.current_client.account_status == 6) {
        history.push('/migrate')
    }

    return (
        <div>
            <Card>
                <CardHeader color="rose" icon>
                    <CardIcon color="rose">
                        <PermIdentity />
                    </CardIcon>
                    <div className={classes.flexEnd}>
                        <h4 className={classes.cardIconTitle}>
                            <FormattedMessage
                                id="forwardList.cardItem1.forwardListing"
                                defaultMessage={`Forwards Listing`}
                            />
                        </h4>
                        <div>
                            <Button
                                round
                                color="primary"
                                onClick={() => toggleModal(true)}
                            >
                                Request a Forward Quote
                            </Button>
                            <Button
                                round
                                color="info"
                                onClick={() => fetchForwardList(app_state.current_client.id)}
                            >
                                <FormattedMessage
                                    id="newTransfer.cardItem1.refresh"
                                    defaultMessage={`Refresh`}
                                />
                            </Button>
                        </div>
                    </div>
                </CardHeader>
                <CardBody>
                    <GridContainer>
                        <GridItem xs={12} sm={12}>
                            <Forwards current={false} status={[8]} />
                        </GridItem>
                    </GridContainer>
                </CardBody>
                <ForwardNewDetail
                    modalState={modalState}
                    toggleModal={toggleModal}
                />
            </Card>
        </div>
    )
}

ForwardsList.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(PastForwardsList)
